import { findIndex } from 'lodash-es';

export const updateStartChannels = (startChannels, groupName, channel) => {
  const index = findIndex(startChannels, ['groupName', groupName]);

  if (index === -1) return [...startChannels, { groupName, channel }];

  const result = startChannels.slice();
  if (channel === -1) {
    result.splice(index, 1);
    return result;
  }

  return result;
};

export const editStartChannel = (startChannels, oldGroupName, newGroupName, newStartChannel) => {
  const index = findIndex(startChannels, ['groupName', oldGroupName]);

  const result = startChannels.slice();
  result[index] = {
    groupName: newGroupName,
    channel: newStartChannel,
  };

  return result;
};
